import AddBid from '../../addBid.js'

export default class EmailMessage{

    _title
    _iframe
    _iframeLoaded = false
    _sideContainer
    uid



    constructor(msg, opts = {}) {
        // let contractor = (CS2.data.customerData[msg.Contractor]??false) ? CS2.data.customerData[msg.Contractor].ShortName : msg.Contractor
        this.options = {
            layout: [
                {tag: 'div', class: 'col-1 badge badge-warning bg-warning text-dark ms-auto text-truncate', content: msg.Contractor},
                {tag: 'div', class: 'col text-truncate', content: msg.projectName},
                {tag: 'div', class: 'col-1  badge text-dark bg-info  text-truncate mx-2', content: msg.subject},
                {tag: 'div', class: 'col-1  badge  bg-dark  text-truncate', content: msg.dueDate},
                {tag: 'div', class: 'col-1 badge bg-light text-dark ms-auto', content: msg.dateFormated},
            ],
            titleBackground: '',//msg.Status === 'Unread' ? 'bg-success-subtle' : 'bg-light',
            ...opts,
        }

        console.log('==>',msg)

        this.id = msg.id
        let title = $('<div>').addClass('row w-100 mx-1').addClass(this.options.titleBackground)
        for (let col of this.options.layout) {
            let obj = $('<'+col.tag+'>').addClass(col.class).html(col.content)
            // console.log('==>',col,obj)
            title.append(obj)
        }

        this._title = title


        // this._title.o = { 'onOpen': ()=>{ this.fetchMsg()}  }

        if(opts.selectable){
            this._title.prepend(
                $('<input>').attr({
                    type: 'checkbox',
                    class: 'form-check-input',
                    name: 'emails',
                    value: msg.id,
                    checked: 'checked'
                })
            )
        }

        this._iframe = $('<iframe>').addClass('col border border-1 border-gray previewTabContainer w-100 ')
        this._sideContainer = opts.sideContainer//$('<div>').addClass('col').html(opts.sideContainer)

        // this.fetchMsg()

    }

    set sideContainer(c) {
        this._sideContainer.html(c)
    }

    get html(){
        return $('<div>').append(this._title, this._iframe)
    }
    get title(){
        return this._title
    }
    get content(){
        return this._iframe
    }

    fetchMsg(){
        if(this._iframeLoaded) return
        this._iframe.attr('srcdoc','Loading...')

        this._iframeLoaded = true
        CS.ajaxCall({
            url: route('emails.get.msg'),
            data: {'id': this.id},
        }, (response) => {
            this._iframe.attr('srcdoc',response.bodies.html)
        })
    }

}
